import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/core/services/account.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { IFamilyMember } from 'src/app/model/contract/IContract';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'pgh-edit-avatar-modal',
  templateUrl: './delete-member-modal.component.html',
  styleUrls: ['./delete-member-modal.component.scss'],
})
export class DeleteMemberModalComponent implements OnInit {
  adpData: any;
  requestorFirstName: string;
  requestorEmail: string;
  memberAvatarUrl: any;
  memberAvatarColor: any;
  member: IFamilyMember;
  fullName: string = '';
  contract: ISelectedContract;
  isSaving = false;

  resourceService = inject(ADPResourceService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<DeleteMemberModalComponent>,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings
  ) {}

  ngOnInit() {
    this.member = this.dialogData.member;
    this.contract = this.dialogData.contract;
    this.adpData = { firstname: this.member.firstName, lastname: this.member.lastName };
    this.loggedInUserSettings.$selectedContract.subscribe((selected) => {
      if (!selected) {
        return;
      }
      this.requestorFirstName = selected.firstName;
      this.requestorEmail = selected.primaryUserEmail;
      selected.members.filter((x) => {
        if (x.emailAddress === this.requestorEmail) {
          this.memberAvatarUrl = x.avatarUrl;
          this.memberAvatarColor = x.profileColor;
          this.fullName = this.member.firstName + ' ' + this.member.lastName;
        }
      });
    });
  }

  onCancelClicked() {
    this.dialogRef.close();
  }

  onDeleteClicked() {
    this.isSaving = true;
    this.accountService.deleteFamilyMember(this.member.emailAddress, this.contract.id).subscribe(() => {
      this.loggedInUserSettings.clearContractFromCache();
      this.dialogRef.close(true);
    });
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
